import { DEFAULT_VALUES } from '../constants/personContactFormConstants';

export const mapRowToFormValues = (row) =>
  row
    ? {
        ContactMethodType: row.ContactMethod || '',
        ContactType: row.MethodType || '',
        ContactInfo: row.Info || '',
        IsDefaultContact: Boolean(row.IsDefault),
        ContactNotes: row.Notes || '',
      }
    : DEFAULT_VALUES;
